import { compose, withState, withHandlers, mapProps } from 'recompose';
import omit from 'ramda/src/omit';
import airports from '../../airports';

const withAutoSuggest = compose(
  withState('airportSuggests', 'setAirportSuggests', []),
  withHandlers({
    suggestAirports: ({ uid, setAirportSuggests }) => value => {
      const q = value.toLowerCase();
      setAirportSuggests(
        airports.filter(a => {
          if (a.code.toLowerCase().includes(q)) return true;
          if (a.name.toLowerCase().includes(q)) return true;
          return false;
        })
      );
    },
    clearAirportSuggs: ({ setAirportSuggests }) => () => {
      setAirportSuggests([]);
    }
  }),
  mapProps(omit(['setAirportSuggests']))
);

export default withAutoSuggest;



// WEBPACK FOOTER //
// ./src/components/hocs/withAirportSuggests.js